<div class="wallet-container mat-typography min-h-250">

    <div class="flex flex-wrap justify-center items-center mt-2 hpx-450" [ngClass]="loading ? 'sm:mb-12 mt-16 p-4' : ''">
        <div class="container flex justify-center m-0 flex-wrap bg-gray-300 items-center w-10/12 min-h-100" style="border-radius: 12px;" *ngIf="loading">
          <mat-spinner
            class="loading-spinner"
            [color]="color"
            [diameter]="diameter"
          >
          </mat-spinner>
        </div>
        <!-- add router outlet here for other component or simply ngif other component? -->
        <div class="flex flex-wrap flex-col justify-center items-center w-full">
          <div class="zapper" id="zapper_virtual">
          </div>
          <button [disabled]="loading" mat-raised-button class="text-xl font-medium rounded-lg flex items-center mt-6 flex justify-center" [ngClass]="mobile ? 'w-11/12' : '' " [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
            <p class="p-0 m-0">CANCEL</p>
          </button>
        </div>
        <span class="flex justify-center w-full p-2 text-center" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">Time remaining: {{ uxFriendlyTime(timeRemaining) }}</span>
    </div>

</div>
